(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    var accordions = document.querySelectorAll('.ls-footer__accordion');
    if (!accordions.length) return;
    var desktopMQ = window.matchMedia('(min-width: 990px)');

    function syncFooterAccordions() {
      accordions.forEach(function(el) {
        if (desktopMQ.matches) el.open = true;
      });
    }

    desktopMQ.addEventListener('change', syncFooterAccordions);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFooterAccordions);
    } else {
      syncFooterAccordions();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // ── Announcement bar rotation ───────────────────────────────────────────────
  class LsAnnouncementBar {
    constructor(el) {
      this.el = el;
      this.messages = Array.from(el.querySelectorAll('.ls-announcement-bar__message'));
      this.current = 0;
      this.delay = 5000;
      this.timer = null;

      if (this.messages.length <= 1) return;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.start();

      el.addEventListener('mouseenter', () => this.stop());
      el.addEventListener('mouseleave', () => this.start());

      window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
        if (e.matches) this.stop(); else this.start();
      });
    }

    start() {
      this.stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.next(), this.delay);
    }

    stop() { clearInterval(this.timer); }

    next() {
      this.messages[this.current].classList.remove('is-active');
      this.messages[this.current].setAttribute('aria-hidden', 'true');
      this.current = (this.current + 1) % this.messages.length;
      this.messages[this.current].classList.add('is-active');
      this.messages[this.current].setAttribute('aria-hidden', 'false');
    }
  }

  const lsBar = document.querySelector('.ls-announcement-bar');
  if (lsBar) new LsAnnouncementBar(lsBar);

  // ── Mega menu hover intent (desktop ≥990px, 200ms delay) ───────────────────
  (function() {
    var OPEN_DELAY  = 200;
    var CLOSE_DELAY = 150;
    var desktopMQ   = window.matchMedia('(min-width: 990px)');

    function initMegaHover() {
      document.querySelectorAll('header-menu .mega-menu').forEach(function(details) {
        var openTimer, closeTimer;

        details.addEventListener('mouseenter', function() {
          if (!desktopMQ.matches) return;
          clearTimeout(closeTimer);
          if (!details.open) {
            openTimer = setTimeout(function() {
              details.setAttribute('open', '');
              details.querySelector('summary').setAttribute('aria-expanded', 'true');
            }, OPEN_DELAY);
          }
        });

        details.addEventListener('mouseleave', function() {
          if (!desktopMQ.matches) return;
          clearTimeout(openTimer);
          if (details.open) {
            var content = details.querySelector('.mega-menu__content');
            if (content) content.classList.add('ls-mega-exiting');
            closeTimer = setTimeout(function() {
              if (content) content.classList.remove('ls-mega-exiting');
              details.removeAttribute('open');
              details.querySelector('summary').setAttribute('aria-expanded', 'false');
            }, CLOSE_DELAY);
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMegaHover);
    } else {
      initMegaHover();
    }
  })();

  // ── StickyHeader ────────────────────────────────────────────────────────────
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.ls-testimonials');

    sections.forEach(function (section) {
      var track = section.querySelector('.ls-testimonials__track');
      var prevBtn = section.querySelector('.ls-testimonials__nav-btn--prev');
      var nextBtn = section.querySelector('.ls-testimonials__nav-btn--next');
      if (!track || (!prevBtn && !nextBtn)) return;

      function scrollByCard(direction) {
        var card = track.querySelector('.ls-testimonial-card');
        if (!card) return;
        var amount = card.getBoundingClientRect().width + 16;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
